<template>
  <div class="myexam-card-container">
    <div class="simple-container">
      <div class="exam-title">
        <div class="title-icon">
          <img class="icon" v-if="itemType == 'exam'" src="/static/img/icon_ks.png" alt="" />
          <img class="icon" v-else src="/static/img/icon_lx.png" alt="" />
        </div>
        <el-tooltip class="item" :content="examtitle" effect="light" placement="top-start">
          <div class="title-text">
            {{ examtitle }}
          </div>
        </el-tooltip>
      </div>
      <div class="exam-time">
        <div>
          <span v-if="itemType == 'exam'">{{ examInfo["exam_manage_goinglistdata.exam_date_time"] }} </span>
          <span v-if="itemType == 'training'">{{ examInfo["exam_training_doingdatalist.training_time"] }} </span>
          <span v-if="examInfo['exam_manage_goinglistdata.exam_time']">{{ examInfo["exam_manage_goinglistdata.exam_time"] }}分钟</span>
        </div>
      </div>
      <div class="exam-num" v-if="itemType == 'exam'">
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_manage_goinglistdata.total_score"] }}
          </div>
          <div class="num-title">考试总分</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_manage_goinglistdata.pass_score"] }}
          </div>
          <div class="num-title">及格分数</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_manage_goinglistdata.exam_num"] }}
          </div>
          <div class="num-title">考试次数</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_manage_goinglistdata.last_num"] }}
          </div>
          <div class="num-title">已考次数</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_manage_goinglistdata.tested_num"] }}
          </div>
          <div class="num-title">剩余次数</div>
        </div>
      </div>
      <div class="exam-num" v-if="itemType == 'training'">
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_training_doingdatalist.num"] }}
          </div>
          <div class="num-title">练习总题</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_training_doingdatalist.checkbox_num"] - 0 + (examInfo["exam_training_doingdatalist.radio_num"] - 0) }}
          </div>
          <div class="num-title">选择题</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_training_doingdatalist.input_num"] }}
          </div>
          <div class="num-title">填空题</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_training_doingdatalist.judge_num"] }}
          </div>
          <div class="num-title">判断题</div>
        </div>
        <div class="num-item">
          <div class="num-value">
            {{ examInfo["exam_training_doingdatalist.last_num"] }}
          </div>
          <div class="num-title">练习次数</div>
        </div>
      </div>
      <div class="exam-divided-line"></div>
      <div class="exam-btnnav" v-if="itemType == 'exam'">
        <DsfButton type="plain" @click="getRules()"> 考生须知 </DsfButton>
        <DsfButton type="plain" @click="checkExam()" v-if="examInfo.isExist == '1'">查看结果</DsfButton>
        <DsfButton @click="continueExam()" v-if="examInfo['viewStatus'] == 2 && examInfo['exam_manage_goinglistdata.exam_num'] !== 0">继续考试</DsfButton>
        <DsfButton
          v-if="(examInfo['viewStatus'] == 1 && examInfo['exam_manage_goinglistdata.exam_num'] !== 0) ||
            (examInfo['viewStatus'] == 4 && queryString.type !== '1')"
          :disabled="examInfo['viewStatus'] == 4"
          @click="startExam()"
        >开始考试</DsfButton>
        <DsfButton v-if="examInfo['viewStatus'] == 3" :disabled="true" @click="openExamTips()">未开始</DsfButton>
        <DsfButton v-if="examInfo['exam_manage_goinglistdata.exam_num'] <= 0" @click="openExamTips()">提示</DsfButton>
      </div>
      <div class="exam-btnnav" v-if="itemType == 'training'">
        <DsfButton
          :type="queryString.type == '0' ? 'plain' : ''"
          @click="checkTraining()"
          v-if="examInfo['exam_training_doingdatalist.last_num'] > 0 && examInfo['exam_training_doingdatalist.num'] > 0"
        >查看练习</DsfButton>
        <DsfButton
          @click="continueTraining()"
          v-if="examInfo['exam_training_doingdatalist.type'] == 2 && examInfo['exam_training_doingdatalist.num'] > 0 && canToTraining === true"
        >继续练习</DsfButton>
        <DsfButton
          v-if="examInfo['exam_training_doingdatalist.type'] == 1 && examInfo['exam_training_doingdatalist.num'] > 0 && canToTraining === true"
          @click="startTraining()"
        >开始练习</DsfButton>
        <DsfButton v-if="showTips === true" @click="openTrainingTips()">提示</DsfButton>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfCardSimpleStyle",
  ctrlCaption: "简洁模式",
  mixins: [$mixins.control],
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return { examInfo: {}, examtitle: "", itemType: "" };
  },
  computed: {
    //是否查看考试
    canCheck() {
      if (this.examInfo["exam_manage_goinglistdata.last_num"] > 0) {
        return true;
      } else {
        return false;
      }
    },

    //是否显示开始考试
    showStartExam() {
      //当前考试 不是继续考试 不是未开始考试
      if (this.examInfo["exam_manage_goinglistdata.type"] !== 2 && this.examInfo["exam_manage_goinglistdata.type"] !== 3) {
        if (this.isDesign) {
          //设计模式
          return true;
        } else if (!this.isDesign && this.queryString.type == "0") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    //是否能够开始考试
    canExam() {
      if (this.examInfo["viewStatus"] !== 3 && this.examInfo["exam_manage_goinglistdata.tested_num"] !== 0) {
        return true;
      } else {
        return false;
      }
    },
    //能否练习
    canToTraining() {
      if (this.examInfo["exam_training_doingdatalist.training_time"] && this.examInfo["exam_training_doingdatalist.training_time"] !== "不限时") {
        if (this.examInfo["exam_training_doingdatalist.type"] !== 3 && this.queryString.type == "0") {
          return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    //是否显示提示按钮
    showTips() {
      var show = false;
      if (this.examInfo["exam_training_doingdatalist.num"] === "0") {
        show = true;
      }
      if (this.examInfo["exam_training_doingdatalist.training_time"] !== "不限时") {
        if (this.queryString.type == "1" && this.examInfo["exam_training_doingdatalist.last_num"] <= "0") {
          show = true;
        }
        if (this.examInfo["exam_training_doingdatalist.type"] === 3) {
          show = true;
        }
      }
      return show;
    },
  },
  created() {
    if (this.isDesign) {
      this.itemType = "exam";
      this.examInfo = {
        "exam_manage_goinglistdata.batch_name": "第1批",
        "exam_manage_goinglistdata.exam_time": 90,
        "exam_manage_goinglistdata.exam_name": "期末考试",
        "exam_manage_goinglistdata.type": 3,
        "exam_manage_goinglistdata.exam_date_time": "2021-10-01 00:00 - 2021-11-30 00:00",
        "exam_manage_goinglistdata.exam_manage_id": "d07a9863d4594d0fbf441d6523cb976c",
        "exam_manage_goinglistdata.pass_score": 60.0,
        "exam_manage_goinglistdata.total_score": 100.0,
        "exam_manage_goinglistdata.exam_num": 5,
        "exam_manage_goinglistdata.tested_num": 4,
        "exam_manage_goinglistdata.last_num": 1,
      };
      this.examtitle = "期末考试 第1批";
    } else {
      this.examInfo = this.value;
      var keyNames = Object.keys(this.examInfo);

      if (keyNames.includes("exam_manage_goinglistdata.exam_name")) {
        //考试列表
        this.itemType = "exam";
        this.examtitle = this.examInfo["exam_manage_goinglistdata.exam_name"] + " " + this.examInfo["exam_manage_goinglistdata.batch_name"];
      } else if (keyNames.includes("exam_training_doingdatalist.name")) {
        //练习列表
        this.itemType = "training";
        this.examtitle = this.examInfo["exam_training_doingdatalist.name"];
      }
    }
  },
  mounted() {},
  methods: {
    openExamTips() {
      dsf.layer.alert("未设置考试次数。");
    },

    showStartNo() {
      //未开始考试
      if (this.examInfo["viewStatus"] === 3) {
        return true;
      } else {
        return false;
      }
    },

    //继续考试
    continueExam() {
      // var pathname = location.pathname.includes("exam") ? "/exam/page.html" : "/page.html";
      var pathname = this.changeStr();
      this.$openWindow(pathname + "#/pc/exam/exam?recordId=" + this.examInfo.recordId + "&type=manage");
    },

    //开始考试
    startExam() {
      var pathname = this.changeStr();
      this.$openWindow(pathname + "#/pc/exam/manage/examinfo?batchId=" + this.examInfo._id + "&share=0");
    },

    //查看结果
    checkExam() {
      var pathname = this.changeStr();
      this.$openWindow(
        pathname +
          "#/pc/exam/check-exam-result?batchId=" +
          this.examInfo._id +
          "&manageId=" +
          this.examInfo["exam_manage_goinglistdata.exam_manage_id"]
      );
    },

    //考生须知
    getRules() {
      this.$openDialog({
        title: "考试须知",
        width: "700px",
        height: "650px",
        overflow: "auto",
        footerAlign: "center",
        params: {
          path: "exam/manage/examinfo?batchId=" + this.examInfo._id,
        },
        btns: [
          {
            text: "确定",
            handler: (res) => {
              res.$dialog.close();
            },
          },
        ],
      });
    },

    //练习提示
    openTrainingTips() {
      var tipsMessge = "";
      var numbers = this.examInfo["exam_training_doingdatalist.num"];
      if (numbers === "0") {
        tipsMessge = "该练习暂未添加试题，无法开启练习，请联系管理员添加试题。";
      }
      if (this.examInfo["exam_training_doingdatalist.training_time"] !== "不限时") {
        if (this.examInfo["exam_training_doingdatalist.type"] === 3) {
          tipsMessge = "该练习暂未开始，请等待。";
        } else if (this.queryString.type == "1") {
          if (this.examInfo["exam_training_doingdatalist.last_num"] <= "0") {
            tipsMessge = "未参与练习，无法查看。";
          }
          if (numbers === "0") {
            tipsMessge = "该练习未添加试题，无法查看练习。";
          }
        }
      }
      dsf.layer.alert(tipsMessge);
    },

    //继续练习
    continueTraining() {
      var pathname = this.changeStr();
      var recordId = dsf.isDef(this.examInfo.recordId) ? this.examInfo.recordId : "";
      this.$openWindow(pathname + "#/pc/exam/exam-practice?id=" + this.examInfo._id + "&recordId=" + recordId);
    },

    //开始练习
    startTraining() {
      var pathname = this.changeStr();
      this.$openWindow(pathname + "#/pc/exam/exam-practice?id=" + this.examInfo._id);
    },

    //查看结果
    checkTraining() {
      var pathname = this.changeStr();
      this.$openWindow(pathname + "#/pc/exam/practice-result?trainingId=" + this.examInfo._id);
    },

    //重新练习
    aginTraining() {
      var pathname = this.changeStr();
      this.$openWindow(pathname + "#/pc/exam/exam-practice?id=" + this.examInfo._id);
    },

    //替换字符串
    changeStr() {
      var pathname = location.pathname;
      var arr = pathname.split("/");
      if (pathname.includes("index.html")) {
        arr.splice(arr.length - 1, 1);
        pathname = arr.join("/") + "/page.html";
      }
      return pathname;
    },
  },
});
</script>

<style></style>
